
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class SaleAgreementRequestModel extends Model<SaleAgreementRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'comment', type: 'string', languageString: 'saleAgreementRequest.property.comment' }
	];
	[key: string]: any;
	
	public comment: string;
    
	constructor(){
		super();
		this.comment = '';
		
	}
	getProperties(){
		return SaleAgreementRequestModel.classProperties;
	}
}

